import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceFaultAuditUserGetOptionsPathParameters } from 'api/actions/device-fault-audit-user-get-options/device-fault-audit-user-get-options-path-parameters';
import { DeviceFaultAuditUserGetOptionsResponse } from 'api/actions/device-fault-audit-user-get-options/device-fault-audit-user-get-options-response';

type DeviceFaultAuditUserGetOptionsQueryParameters = Record<string, any>;

/**
 * The path of the DeviceFaultAuditUserGetOptions action.
 */
export const deviceFaultAuditUserGetOptionsActionPath = new SweetPath<
  keyof DeviceFaultAuditUserGetOptionsPathParameters
>('/api/device/faults/user-options', { path: '{param}' });

/**
 * Creates a contextualized DeviceFaultAuditUserGetOptions actions.
 */
export default function createDeviceFaultAuditUserGetOptionsAction(axios: AxiosInstance) {
  return function deviceFaultAuditUserGetOptionsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: DeviceFaultAuditUserGetOptionsQueryParameters } = {}) {
    const path = deviceFaultAuditUserGetOptionsActionPath.original;

    return axios.request<DeviceFaultAuditUserGetOptionsResponse, DeviceFaultAuditUserGetOptionsResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
